import { Container, Stack, Title, Text, Flex, Button, Center, Loader, ScrollArea } from "@mantine/core";
import { COLORS } from "../../../../constants/colorConstants";
import ErrorCard from "../../../../shared/components/blocks/ErrorCard";
import { useDeleteCalendars } from "../../../../hooks/calendars/useDeleteCalendars";
import { buildPartialDeleteError } from "../utils/errorUtils";

export default function CalendarDeletionDialog({ calendarIds }) {
  const deleteCalendars = useDeleteCalendars();

  const label = calendarIds.length === 1 ? "calendar" : "calendars";

  const handleSubmit = async () => {
    await deleteCalendars.mutateAsync(calendarIds);
  };

  const renderContent = () => {
    if (deleteCalendars.error) {
      return <ErrorCard error={deleteCalendars.error} />;
    }

    if (!deleteCalendars.data?.success && deleteCalendars.data?.failed?.length > 0) {
      const error = buildPartialDeleteError({ items: deleteCalendars.data.failed });

      return <ErrorCard error={error} />;
    }

    return <></>;
  };

  return (
    <Container fluid>
      <Stack>
        <Title order={3}>
          Are you sure you want to delete {calendarIds.length} {label}?
        </Title>
        <ScrollArea type="hidden" style={{ height: 520 }}>
          <Text c="red" fw={600}>
            This action is irreversible. You will delete the children data of calendars too such as dates.
          </Text>
          {renderContent()}
        </ScrollArea>
        <Flex justify="flex-end">
          <Button
            size="sm"
            radius="md"
            color={COLORS.DARK_WINE}
            loading={deleteCalendars.isPending}
            onClick={handleSubmit}
          >
            Confirm
          </Button>
        </Flex>
      </Stack>
    </Container>
  );
}
